import Animation from './animation'
import * as d3 from 'd3-selection'
import { EPSILON } from 'chart-constants'

/*
 * This animation is used when we're showing data that is in a tree format.
 * It's used when there are no breakdowns within the plot. When an update
 * occurs where the incoming series have a `parentId` property that matches
 * one of the series leaving, this animation is activated.
 *
 * This animation is a bit weird compared to others, because it waits until
 * the final serie should be updated, then runs the correct animations
 */
class HierarchyDrilldownAnimation extends Animation {

 constructor (options) {
   super(options)
   this.twoPart = true
   this.ripple = true

   // Track how many times the animate method is called, since we're animating many series at once
   this.animated = 0
 }

 match (serie) {
   let match = false

   // Calculated breakdown indicating we're showing a bunch of series without a breakdown
   if (this.chart.layout.breakdown.calculated && this.series.size()) {
     // If series are being removed and we're removing all of the series
     if (this.exitingSeries.size() && this.previous.series.size() === this.exitingSeries.size()) {
       // Do the new series have a parentId that matches one of the series that's leaving?
       let parentId = this.series.selection().data()[0].parentId // We're grabbing the first one, but they should all be the same
         , exitingIds = this.exitingSeries.selection().data().map(serie => serie.id)

       if (parentId && exitingIds.indexOf(parentId) !== -1) {
         this.parentId = parentId
         match = true
       }
     }
   }

   return match
 }

 animate () {
   // Wait until the positioning code runs for each serie (exiting and new series)
   if (++this.animated === (this.exitingSeries.size() + this.series.size())) {
     // Grab the exiting serie that matches the `parentId` of the new series
     let parent = this.exitingSeries.filter(serie => serie.id === this.parentId).selection()
       , dim = this._getDimensions(parent)

     // Fade out all the old bars immediately
     this.exitingSeries.duration(this.timing.duration)
                       .style('opacity', EPSILON)

     // The entering series are placed on top of this parent serie.
     // Remove the parent serie immediately so we don't see it fade as
     // the new series move to their end location
     parent.remove()

     // Collect all the entering points from each of the new series and form a new selection
     let enter = d3.selectAll(this.series.selection().selectAll('g.rect').nodes())

     // Put the nodes into the DOM, splitting them from the parent serie's dimensions
     this._split(enter, dim)
   }
 }

}

export default HierarchyDrilldownAnimation
